import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import type { Session, User } from "@supabase/supabase-js";
import { supabase } from "./supabase";

type AuthState = { session: Session | null; user: User | null; recovery: boolean; loading: boolean; signOut: () => Promise<void>; clearRecovery: () => void };
const Ctx = createContext<AuthState>({ session: null, user: null, recovery: false, loading: true, signOut: async () => {}, clearRecovery: () => {} });

export function AuthProvider({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);
  const [recovery, setRecovery] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => { setSession(data.session); setLoading(false); });
    const { data: sub } = supabase.auth.onAuthStateChange((event, s) => { setSession(s); if (event === "PASSWORD_RECOVERY") setRecovery(true); });
    return () => sub.subscription.unsubscribe();
  }, []);

  const signOut = async () => { await supabase.auth.signOut(); };
  const clearRecovery = () => setRecovery(false);
  return <Ctx.Provider value={{ session, user: session?.user ?? null, recovery, loading, signOut, clearRecovery }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
